import React from 'react';
import PropTypes from 'prop-types';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import color from '../../../../../config/colors.json';
import Card from '../../../Card';
import * as Style from './style';

const CustomTooltip = ({ payload, active }) => {
	const parseDate = date => new Date(date).toLocaleDateString('pt-BR', { dateStyle: 'full' });

	const customTooltip = active
	? (
		<Card border={`1px solid ${color.lightGrey2}`} padding="11px 15px 15px">
			<div className="d-flex flex-column">
				<Style.TooltipLabel style={{ marginBottom: '9px' }}>
					{ parseDate(payload[0].payload.day) }
				</Style.TooltipLabel>
				<div className="d-flex justify-content-between" style={{ marginBottom: '9px' }}>
					<div className="d-flex align-items-center" style={{ marginRight: '83px' }}>
						<Style.TooltipLegend legendColor={color.redButtons} />
						<Style.TooltipLabel>Cliques</Style.TooltipLabel>
					</div>
					<Style.TooltipLabel>{ payload[0].payload.clicks }</Style.TooltipLabel>
				</div>
				<div className="d-flex justify-content-between">
					<div className="d-flex align-items-center" style={{ marginRight: '83px' }}>
						<Style.TooltipLegend />
						<Style.TooltipLabel>Impressões</Style.TooltipLabel>
					</div>
					<Style.TooltipLabel>{ payload[0].payload.impressions }</Style.TooltipLabel>
				</div>
			</div>
		</Card>
	)
	: <></>;

	return customTooltip;
	};

const CustomLegend = () => (
	<Style.CaptionContainer>
		<div>
			<Style.Caption legendColor={color.redButtons} />
			<Style.CaptionLabel>Cliques</Style.CaptionLabel>
			<Style.Caption />
			<Style.CaptionLabel>Impressões</Style.CaptionLabel>
		</div>
		<em>Dados dos últimos 30 dias*</em>
	</Style.CaptionContainer>
);

const SimpleLineChart = ({ data }) => (
	<Style.ChartDiv>
		<ResponsiveContainer width="100%" minWidth="100%" height={295} debounce={1}>
			<LineChart
				data={data}
				margin={{
					top: 5, right: -25, bottom: 5, left: -25,
				}}
				style={{ zIndex: 30 }}
			>
				<CartesianGrid strokeDasharray="3 3" />
				<YAxis yAxisId="left" />
				<YAxis yAxisId="right" orientation="right" />
				<XAxis tick={false} tickSize={0} strokeWidth={3} stroke={color.lightGrey8} />
				<Tooltip content={<CustomTooltip payload={data} />} />
				<Line yAxisId="left" strokeWidth={3} dot={false} type="monotone" dataKey="clicks" stroke={color.redButtons} activeDot={{ r: 8 }} />
				<Line yAxisId="right" strokeWidth={3} dot={false} type="monotone" dataKey="impressions" stroke={color.darkGreyMidias} />
				<Legend content={<CustomLegend />} />
			</LineChart>
		</ResponsiveContainer>
	</Style.ChartDiv>
);

PropTypes.SimpleLineChart = {
	data: PropTypes.array.isRequired,
};

PropTypes.CustomTooltip = {
	active: PropTypes.bool,
	payload: PropTypes.array.isRequired,
};

export default SimpleLineChart;
